module.exports = __webpack_public_path__ + "static/media/chevron-down-thin-24.1667eab2.svg";